'use client';
import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeSubscriptionCountData } from '../types';

type SubscriptionsParams = {
  userUuid: string;
  statuses: string[];
  fullSubscriptionsOnly?: boolean;
};

export default function useSubscriptionsCount(params: SubscriptionsParams) {
  const { userUuid, statuses, fullSubscriptionsOnly } = params;
  const queryParams = new URLSearchParams();

  if (fullSubscriptionsOnly !== undefined) {
    queryParams.append('full_subscription', fullSubscriptionsOnly.toString());
  }

  statuses.forEach((status) => queryParams.append('status[]', status));

  const subscriptionsUri = `${
    API_URLS.SUBSCRIPTION_MANAGER_PROXY
  }/recipient/${userUuid}/subscriptions_count?${queryParams}`;

  return useSWR<TypeSubscriptionCountData, Error>(
    subscriptionsUri,
    SWR_REQUEST_DEFAULTS,
  );
}
